module.exports = __webpack_public_path__ + "img/nadia_medina.17a37459.jpg";